module.exports = __webpack_public_path__ + "img/background062.jpg";